import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { ExclusionSavingsResponse } from "@/services/dashboard/dashboard-api";
import { HTSCodeWithTooltip } from "@/components";

export const createExclusionsColumns = (): IColumn<ExclusionSavingsResponse["data"][number]>[] => [
  {
    name: "HTS Code",
    key: "htsCode",
    align: "left",
    width: "16%",
    component: (row) => (
      <HTSCodeWithTooltip htsCode={row.htsCode}>
        <Box sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer', '&:hover': { color: '#0b494b', textDecoration: 'underline' } }}>
          {row.htsCode}
        </Box>
      </HTSCodeWithTooltip>
    ),
    sorting: true,
  },
  {
    name: "99 Code",
    key: "code99",
    align: "left",
    width: "12%",
    component: (row) => (
      <Tooltip title={row.code99} arrow placement="top">
        <Box sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.code99}</Box>
      </Tooltip>
    ),
    sorting: true,
  },
  {
    name: "Entry Count",
    key: "entryCount",
    align: "left",
    width: "12%",
    component: (row) => <Box sx={{ fontSize: { xs: '11px', md: '12px' } }}>{row.entryCount}</Box>,
    sorting: true,
  },
  {
    name: "Status",
    key: "active",
    align: "left",
    width: "10%",
    component: (row) => (
      <Chip 
        label={row.active ? 'Active' : 'Expired'}
        color={row.active ? 'success' : 'error'}
        size="small"
        sx={{ color: !row.active ? '#fff' : undefined, backgroundColor: !row.active ? '#d32f2f' : undefined, borderColor: !row.active ? '#d32f2f' : undefined }}
      />
    ),
  },
  {
    name: "Goods Value",
    key: "goodsValue",
    align: "left",
    width: "14%",
    component: (row) => <Box sx={{ fontSize: { xs: '11px', md: '12px' } }}>${row.goodsValue.toLocaleString()}</Box>,
    sorting: true,
  },
  {
    name: "Current Duty Rate",
    key: "oldDutyRate",
    align: "left",
    width: "12%",
    component: (row) => <Box sx={{ fontSize: { xs: '11px', md: '12px' } }}>{row.oldDutyRate}</Box>,
    sorting: true,
  },
  {
    name: "New Duty Rate",
    key: "newDutyRate",
    align: "left",
    width: "12%",
    component: (row) => <Box sx={{ fontSize: { xs: '11px', md: '12px' } }}>{row.newDutyRate}</Box>,
    sorting: true,
  },
  {
    name: "Potential Savings",
    key: "savings",
    align: "left",
    width: "12%",
    sorting: true,
    component: (row) => (
      <Box sx={{ fontSize: { xs: '11px', md: '12px' }, color: '#0B494B', fontWeight: 600 }}>
        ${row.savings.toLocaleString()}
      </Box>
    ),
  },
  {
    name: "Description",
    key: "description",
    align: "left",
    width: "20%",
    component: (row) => (
      <Tooltip title={row.description} placement="top-start">
        <Typography component="p" sx={{
          maxWidth: 400,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          lineHeight: '1.2em',
          maxHeight: '3.6em',
          whiteSpace: 'normal',
          margin: 0,
          fontSize: '11px',
        }}>
          {row.description}
        </Typography>
      </Tooltip>
    ),
  },
];

export const exclusionsColumns: IColumn<ExclusionSavingsResponse["data"][number]>[] = createExclusionsColumns();


